import React, { useState } from 'react';
import styles from './TranslatorPage.module.scss';
import { ServiceOptions, Translator } from 'app/components';
import { Card } from '@zurich-primitives/card';
import { Globe } from '@zurich-data-dsm-icons/communication.globe';
import { FileText } from '@zurich-data-dsm-icons/communication.file.file-text';
import { FileTranslator } from 'app/components/Sections/FileTranslator';
import { TranslatorHistory } from 'app/components/Sections/TranslatorHistory';
import { ReactComponent as HistoryIcon } from 'app/assets/Icons/History.svg';
import { Switch } from '@zurich-base-ui/components.switch';

const TRANSLATOR_SECTIONS = {
  TEXT: 'TEXT',
  FILE: 'FILE',
  HISTORY: 'HISTORY'
};

export const TranslatorPage: React.FC = () => {
  const [activeSection, setActiveSection] = useState<string>(
    TRANSLATOR_SECTIONS.TEXT
  );
  const [medicalMode, setMedicalMode] = useState<boolean>(false);

  return (
    <div className={styles['translator-container']}>
      <ServiceOptions />

      <div className={styles['card-container']}>
        <div className={styles['translation-modes']}>
          <Card
            hover
            className={styles.card}
            onClick={() => setActiveSection(TRANSLATOR_SECTIONS.TEXT)}
          >
            <Globe />
            <p>Translate Text</p>
          </Card>

          <Card
            hover
            className={styles.card}
            onClick={() => setActiveSection(TRANSLATOR_SECTIONS.FILE)}
          >
            <FileText />
            <p>Translate File</p>
          </Card>
        </div>

        <div className={styles['translation-history']}>
          <Card
            hover
            className={styles.card}
            onClick={() => setActiveSection(TRANSLATOR_SECTIONS.HISTORY)}
          >
            <HistoryIcon />
            <p>File Translation History</p>
          </Card>
        </div>
      </div>

      <div
        className={styles['medical-mode-container']}
        style={{
          display: activeSection === TRANSLATOR_SECTIONS.TEXT ? 'flex' : 'none'
        }}
      >
        <Switch
          status={medicalMode ? 'on' : 'off'}
          onClick={() => setMedicalMode(!medicalMode)}
          id={'medical-translation'}
          className={styles['switch-style']}
        />
        <span className={styles['switch-label']}>Medical Translation</span>
      </div>

      <div>
        {activeSection === TRANSLATOR_SECTIONS.TEXT && (
          <Translator medicalMode={medicalMode} />
        )}
        {activeSection === TRANSLATOR_SECTIONS.FILE && <FileTranslator />}
        {activeSection === TRANSLATOR_SECTIONS.HISTORY && <TranslatorHistory />}
      </div>
    </div>
  );
};
